<template>
  <v-container fluid>
    <v-row v-if="loading">
      <v-col>
        <v-alert type="info">
          กำลังโหลดข้อมูล...
        </v-alert>
      </v-col>
    </v-row>

    <v-row v-else-if="error">
      <v-col>
        <v-alert type="error">
          เกิดข้อผิดพลาด: {{ error }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row
      v-else
      class="fill-height">
      <!-- ฝั่งซ้าย -->
      <v-col
        v-show="$vuetify.breakpoint.smAndUp"
        cols="12"
        md="4"
        class="pa-4 packing-list-collections">
        <div class="table-wrapper">
          <v-simple-table dense>
            <tbody>
              <tr
                v-for="col in collections"
                :key="col.name"
                :class="['hover:bg-gray-100', col.name === selectedCollection ? 'bg-gray-100' : '']"
                style="cursor: pointer;"
                @click="onSelectCollection(col)">
                <td>
                  <v-chip
                    :class="['ma-1', `bg-${getMonth(col['Launch Date'])}`]"
                    label
                    text-color="secondary">
                    {{ getMonth(col['Launch Date']).toUpperCase() }} {{ getYear(col['Launch Date']) }}
                  </v-chip>
                </td>
                <td>{{ col.name }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-col>

      <!-- ฝั่งขวา -->
      <v-col
        cols="12"
        md="8"
        class="pa-4 print-packing-list">
        <div class="table-wrapper">
          <v-card
            v-if="selectedCollection"
            class="pa-4"
            flat>
            <div class="d-flex justify-space-between align-center w-100">
              <div>
                <p class="headline font-weight-bold mb-0 pl-0">
                  {{ selectedCollection }}
                </p>
                <p class="text-h6 mb-0 font-weight-medium">
                  ทั้งหมด {{ collection.length }} แบบ
                </p>
                <p
                  class="text-h6 pl-0">
                  วันขาย {{ launchDate | dateUserFormat() }}
                </p>
              </div>
              <div
                id="print-btn"
                class="d-flex mb-4">
                <v-btn
                  color="secondary"
                  class="ml-auto"
                  @click="printTable()">
                  Print
                </v-btn>
              </div>
            </div>
            <v-simple-table class="bordered-table">
              <tbody>
                <tr
                  v-for="(row, index) in collection"
                  :key="index">
                  <td
                    class="text-h5 text-center"
                    width="20px">
                    {{ index + 1 }}
                  </td>
                  <td
                    class="text-h5 text-center"
                    width="100px">
                    {{ row.Color }}
                  </td>
                  <td width="100px">
                    <img
                      class="py-1"
                      :src="`https://gw-mer-api-production-dclzrwc4na-as.a.run.app/public/prototype/fitting-image/${getColor(row.Color)}/sketch-id`"
                      height="96"
                      contain />
                  </td>
                  <td width="100px"></td>
                  <td width="100px"></td>
                  <td width="100px"></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
          <v-card
            v-else
            class="pa-4 text-center"
            flat>
            เลือก Collection เพื่อดูรายละเอียด
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      collections: [],
      worksheet: {},
      selectedCollection: '',
      loading: true,
      error: null,
      launchDate: null,
      collection: null
    }
  },
  mounted () {
    this.fetchWorkSheet()
  },
  methods: {
    async fetchWorkSheet () {
      fetch(`https://storage.googleapis.com/gw_production_plan/worksheet.json?passKey=${Date.now()}`)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch data')
          return response.json()
        })
        .then((data) => {
          this.worksheet = data
          Object.keys(this.worksheet).forEach((key) => {
            if (key !== null && key !== 'null' && this.worksheet[key][0]['Launch Date']) {
              this.collections.push({
                'name': key,
                'Launch Date': this.worksheet[key][0]['Launch Date'][0]
              })
            }
          })
          const sixMonthsLater = this.$dayjs().add(6, 'month').valueOf()
          this.collections = this.collections
            .filter((col) => col['Launch Date'] <= sixMonthsLater)
            .sort((a, b) => a['Launch Date'] - b['Launch Date'])
        })
        .catch((err) => {
          this.error = err.message
        })
        .finally(() => {
          this.loading = false
        })
    },
    getMonth (date) {
      if (!date) return '-'
      return this.$dayjs(date).format('MMM').toLowerCase()
    },
    getYear (date) {
      if (!date) return '-'
      return this.$dayjs(date).format('YYYY')
    },
    printTable () {
      window.print()
    },
    onSelectCollection (col) {
      this.selectedCollection = col.name
      this.collection = this.worksheet[this.selectedCollection]
      this.launchDate = this.collection?.[0]?.['Launch Date']?.[0] ?? null
    },
    getColor (color) {
      if (color && color !== 'null') {
        return color.trim()
      }
        return 'default'
    }
  }
}
</script>

<style>
.bg-jan { background-color: #FFD1DC !important; }
.bg-feb { background-color: #FFDFBA !important; }
.bg-mar { background-color: #B5AEE3 !important; }
.bg-apr { background-color: #D4E157 !important; }
.bg-may { background-color: #A1E5AB !important; }
.bg-jun { background-color: #A7C7E7 !important; }
.bg-jul { background-color: #FFEBB4 !important; }
.bg-aug { background-color: #dfc6f7 !important; }
.bg-sep { background-color: #FDDDE6 !important; }
.bg-oct { background-color: #d7ffa0 !important; }
.bg-nov { background-color: #e5a3da !important; }
.bg-dec { background-color: #C5DFF8 !important; }
.bordered-table {
  width: 100% !important;
  border: 1px solid #ccc;
}

.bordered-table table {
  border-collapse: collapse;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid #ccc;
  padding: 8px;
}

.table-wrapper {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  border: 1px solid #ccc;
}

.table-wrapper table {
  border-collapse: collapse;
}

.table-wrapper th,
.table-wrapper td {
  border: 1px solid #ccc;
  padding: 8px;
}

@media print {
  .table-wrapper {
    height: auto !important;
    border: 0;
    overflow-y: visible;
  }
  #sidebar {
    display: none !important;
  }

  .packing-list-collections {
    display: none !important;
  }

  #print-btn {
    display: none !important;
  }

  .v-sheet.theme--light.v-toolbar.v-toolbar--dense.v-app-bar.v-app-bar--fixed {
    display: none !important;
  }

  .print-packing-list {
    width: 100% !important;
    page-break-after: always;
    page-break-before: always;
    clear: both;
  }
  #app main.v-main {
    padding: 0 !important;
  }
}
</style>
